import React from 'react';
import PropTypes from 'prop-types';
import { FDIcon, FDPaper } from '@facet-wealth/design';

export const PillarActionItemIconPrePlan = ({ isDisabled, isCompleted, isOverdue }) => {
  const iconProps = {
    icon: 'circleOutline',
    color: 'textPrimary',
  };

  if (isCompleted) {
    iconProps.icon = 'checkCircleIcon';
  } else if (isDisabled) {
    iconProps.icon = 'lockCircleOutline';
    iconProps.color = 'textDisabled';
  } else if (isOverdue) {
    iconProps.icon = 'error';
    iconProps.color = 'error';
  }

  return (
    <FDPaper appearance={'flat'}>
      <FDIcon {...iconProps} />
    </FDPaper>
  );
};

PillarActionItemIconPrePlan.defaultProps = {
};

PillarActionItemIconPrePlan.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  isOverdue: PropTypes.bool.isRequired,
};
